<template>
  <div class="rich-text">
    <div class="btn-toolbar border rounded-top bg-light p-1 gap-1" role="toolbar">
      <button
        v-for="button in buttons"
        :key="button.command + (button.value || '')"
        type="button"
        class="btn btn-sm btn-outline-secondary"
        :title="button.title"
        @mousedown.prevent="run(button)"
      >
        <span v-html="button.label"></span>
      </button>
    </div>
    <div
      ref="editor"
      class="form-control rounded-0 rounded-bottom rich-text-area"
      contenteditable="true"
      @input="emitChange"
      @blur="emitChange"
    ></div>
    <div class="form-text">
      Жирный, курсив, списки, заголовки и таблицы сохраняются. Всё остальное
      форматирование сервер вырезает: описание показывается на публичной странице.
    </div>
  </div>
</template>

<script>
export default {
  name: 'RichText',
  props: {
    modelValue: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      buttons: [
        { command: 'bold', label: '<strong>Ж</strong>', title: 'Жирный' },
        { command: 'italic', label: '<em>К</em>', title: 'Курсив' },
        { command: 'underline', label: '<u>Ч</u>', title: 'Подчёркнутый' },
        { command: 'formatBlock', value: 'h4', label: 'H', title: 'Заголовок' },
        { command: 'formatBlock', value: 'p', label: '¶', title: 'Обычный текст' },
        { command: 'insertUnorderedList', label: '•', title: 'Маркированный список' },
        { command: 'insertOrderedList', label: '1.', title: 'Нумерованный список' },
        { command: 'removeFormat', label: '✕', title: 'Убрать форматирование' }
      ]
    }
  },
  mounted() {
    this.$refs.editor.innerHTML = this.modelValue || ''
  },
  watch: {
    // Подставляем текст извне только когда редактор не в фокусе, иначе
    // курсор прыгает в начало на каждом нажатии клавиши
    modelValue(value) {
      const editor = this.$refs.editor
      if (editor && document.activeElement !== editor && editor.innerHTML !== value) {
        editor.innerHTML = value || ''
      }
    }
  },
  methods: {
    run(button) {
      this.$refs.editor.focus()
      document.execCommand(button.command, false, button.value || null)
      this.emitChange()
    },
    emitChange() {
      this.$emit('update:modelValue', this.$refs.editor.innerHTML)
    }
  }
}
</script>

<style scoped>
.rich-text-area {
  min-height: 180px;
  max-height: 420px;
  overflow-y: auto;
}

.rich-text-area:focus {
  box-shadow: none;
  border-color: #86b7fe;
}

/* Как и на странице паспорта: широкая таблица прокручивается внутри себя */
.rich-text-area :deep(table) {
  display: block;
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
  margin-bottom: 0.5rem;
}

.rich-text-area :deep(td),
.rich-text-area :deep(th) {
  border: 1px solid #dee2e6;
  padding: 0.25rem 0.5rem;
}
</style>
